// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1vX1-","box":"WorkspacesBox_box__1qoH_","node":"WorkspacesBox_node__gX2Qj"};